import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import { EfectivoConst } from './efectivo-const';
import { EfectivoDialogDeleteComponent } from './efectivo-dialog-delete.component';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { EfectivoDialogFormComponent } from './efectivo-dialog-form.component';
import { EfectivoDialogIngresoACajaComponent } from './efectivo-dialog-ingreso-a-caja.component';
import { EfectivoDialogMovimientoSocioComponent } from './efectivo-dialog-movimiento-socio.component';
import { TableService } from '../../../shared/components/table/table.service';
import { AccountingAccountsDialogLedgerComponent } from '../../accounting/accounting-accounts/accounting-accounts-dialog-ledger.component';
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { consts } from '../../../consts';
import { Utils } from '../../../shared/utils';

@Component({
    selector: 'convfact-efectivo-list',
    templateUrl: './efectivo-list.component.html',
    styleUrls: [],
    standalone: false
})
export class EfectivoListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  public headerTable: any[] = EfectivoConst.headerTable;

  public dataSource: Efectivo[] = [];

  public empty: boolean = false;
  public ready: boolean = false;
  public spinner: boolean = false;

  constructor(
    private efectivoService: EfectivoService,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public dummy: DummyComponent,
    private tableService: TableService,
    private accountingAccountsService: AccountingAccountsService,
  ) { }

  public ngOnInit(): void {
    this.dataSource = [];
    this.getList();
  }

  public getList() {
    this.efectivoService.tableList(this.currentPage, this.itemsPerPage)
      .then(data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public create(): void {
    this.dialog.open(EfectivoDialogFormComponent, {
      data: { efectivo: undefined, isEditMode: false }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public edit(uid: string): void {
    // Buscamos el obtejo y se lo pasamos al modal de pago
    const efectivoSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(EfectivoDialogFormComponent, {
      data: { efectivo: efectivoSelected, isEditMode: true }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public ingresodebanco(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const efectivoSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(EfectivoDialogIngresoACajaComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { efectivo: efectivoSelected }
    })
      .afterClosed().subscribe((changes: boolean) => {

        if (changes) {
          this.dummy.redirectTo(this.router.url)
        }

      });
  }

  public movimientosocio(uid: string, tipoMovimientoSocioId: number): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const efectivoSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(EfectivoDialogMovimientoSocioComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { efectivo: efectivoSelected, tipoMovimientoSocioId: tipoMovimientoSocioId }
    })
      .afterClosed().subscribe((changes: boolean) => {

        if (changes) {
          this.dummy.redirectTo(this.router.url)
        }

      });
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(EfectivoDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public mayor(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    let accountingModelsResponse: AccountingAccountsModel[] = [];
    let accountingModels: AccountingAccountsModel = new AccountingAccountsModel();

    this.accountingAccountsService.list(0, 1, searchedElement.accountingModelsNumber)
      .subscribe((x: any) => {
        accountingModelsResponse = x.data;

        if (accountingModelsResponse && accountingModelsResponse.length === 1) {
          accountingModels = accountingModelsResponse[0];
        }

        this.dialog.open(AccountingAccountsDialogLedgerComponent, {
          width: '700px',
          maxWidth: '96vw',
          
          maxHeight: '90vh',
          autoFocus: false,
          data: {
            id: accountingModels.id,
            name: accountingModels.name,
            number: accountingModels.number
          }
        });
      });
  }

  public trackByIndex(i: number) { return i; }

}
